import React from 'react';
import { View, StyleSheet, Image, TouchableOpacity } from 'react-native';
import { useActionSheet } from '@expo/react-native-action-sheet';
import { CommonProperties, Color, CommonStyles } from '../../styles';
import RowView from '../RowView';
import BaseText from '../BaseText';
import Icon from '../Icon';
import { useNavigation } from '@react-navigation/native';
import { Modals } from '../../constants/ScreenNames';
import TravelerList from './Traveler/TravelerList';
import { AvatarActionTypes } from './Traveler/AvatarTraveler';
import Chat from './Chat/Chat';
import { userTypes } from '../../constants/Enums';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';

const groupOptions = ['Edit Group', 'Edit Comments'];
const Group = ({ disable, data, users, userType }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('TripHubScreen');
  const navigation = useNavigation();
  const { showActionSheetWithOptions } = useActionSheet();
  const onSelection = (buttonIndex) => {
    if (buttonIndex === 0) {
      // TODO: Add params to change the button update
      navigation.navigate(Modals.InviteTravelerModal);
    } else if (buttonIndex === 1) {
      console.log('on edit comments');
    }
  };

  if (disable) {
    return (
      <View
        style={{
          backgroundColor: 'white',
          ...CommonProperties.pt5,
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
        }}
      >
        <Icon
          style={{ color: Color.text.medium, ...CommonProperties.mt5 }}
          name="people"
          size={72}
        />
        <BaseText style={{ ...CommonProperties.h1, color: Color.text.medium, textAlign: 'center' }}>
          {t('Group.Newfeaturecomingsoon')}
        </BaseText>
        <BaseText
          style={{
            ...CommonProperties.h3,
            color: Color.text.medium,
            ...CommonProperties.mt3,
            textAlign: 'center',
          }}
        >
          {t('Group.Planningforsmallgroupsoroutofto')}
        </BaseText>
      </View>
    );
  }

  if (users.length > 0) {
    return (
      <View style={styles.container}>
        {userTypes.OWNER !== userType ? (
          <BaseText style={[CommonStyles.px3, CommonStyles.py4, CommonStyles.h4]}>
            That time of year folks, annual sales meet and greet. Make sure to get there by 10am on
            June 20.
          </BaseText>
        ) : null}
        <RowView style={styles.header}>
          <BaseText>{t(tKey('InviteAtendees'))}</BaseText>
          {userTypes.OWNER === userType ? (
            <TouchableOpacity
              onPress={() => showActionSheetWithOptions({ options: groupOptions }, onSelection)}
            >
              <Icon name="settings" color={Color.primary} size={22} />
            </TouchableOpacity>
          ) : null}
        </RowView>
        <TravelerList
          avatarActionType={AvatarActionTypes.ACTIVE}
          list={users}
          enableInvite={userTypes.OWNER === userType}
          onPressInvite={() => navigation.navigate(Modals.InviteTravelerModal)}
        />
        <Chat data={data} />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <Image source={require('../../assets/img/meeting.png')} style={styles.bckImage} />
      <View style={styles.textWrap}>
        <RowView style={styles.header}>
          <BaseText style={styles.headerLabel}>{t(tKey('InviteAtendees'))}</BaseText>
          <TouchableOpacity
            onPress={() => showActionSheetWithOptions({ options: groupOptions }, onSelection)}
          >
            <Icon name="settings" color={Color.accent} size={22} />
          </TouchableOpacity>
        </RowView>
        <View style={styles.plusWrap}>
          <TouchableOpacity
            onPress={() => {
              navigation.navigate(Modals.InviteTravelerModal);
            }}
          >
            <Icon name="circlePlus" color={Color.accent} size={62} />
          </TouchableOpacity>
          <BaseText style={styles.plusText}>
            Invite Travelers to get the discussion started for DFW - MIA
          </BaseText>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    ...CommonProperties.pb3,
  },
  header: {
    justifyContent: 'space-between',
    alignItems: 'center',
    ...CommonProperties.p3,
  },
  headerLabel: {
    color: Color.accent,
  },
  headerLabel1: {
    color: Color.accent,
  },
  textWrap: {
    ...StyleSheet.absoluteFillObject,
  },
  plusWrap: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  plusText: {
    color: Color.accent,
    textAlign: 'center',
    ...CommonProperties.h4,
    ...CommonProperties.p5,
    ...CommonProperties.mx5,
  },
  bckImage: {
    width: '100%',
    height: '100%',
    resizeMode: 'cover',
  },
});

export default Group;
